import React from "react"

const SuccessIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
    >
      <path
        d="M11 0C5.204 0 0.5 4.704 0.5 10.5C0.5 16.296 5.204 21 11 21C16.796 21 21.5 16.296 21.5 10.5C21.5 4.704 16.796 0 11 0ZM8.1545 15.0045L4.385 11.235C3.9755 10.8255 3.9755 10.164 4.385 9.7545C4.7945 9.345 5.456 9.345 5.8655 9.7545L8.9 12.7785L16.124 5.5545C16.5335 5.145 17.195 5.145 17.6045 5.5545C18.014 5.964 18.014 6.6255 17.6045 7.035L9.635 15.0045C9.236 15.414 8.564 15.414 8.1545 15.0045Z"
        fill="#4FD600"
      />
    </svg>
  )
}

export default SuccessIcon
